import { useLayoutEffect, useState } from 'react';

import { TextPropsRequired } from '../components/axes/types.js';
import { getTokenComputedStyle } from '../utils/getTokenComputedStyle.js';

/**
 * Gets computed style after mounting component
 *
 * @returns current format font for font token
 */
export const useComputedFontStyle = (fontProps: TextPropsRequired) => {
  const [fontStyle, setFontStyle] = useState(fontProps);
  const { fill, fontSize, fontFamily } = fontProps;
  useLayoutEffect(() => {
    setFontStyle((prev) => ({
      ...prev,
      fill: getTokenComputedStyle(fill),
      fontSize: getTokenComputedStyle(fontSize),
      fontFamily: getTokenComputedStyle(fontFamily),
    }));
  }, [fill, fontFamily, fontSize]);

  return fontStyle;
};
